module.exports = __webpack_public_path__ + "media/images/icon-instagram-white-59124286ca5db38345cd9302182eec31.svg";